module.exports = __webpack_public_path__ + "static/media/jun.fffcf4dc.jpg";